module.exports = __webpack_public_path__ + "img/person.61779296.svg";